import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";

export type GenerateLetterRequest = {
  collectionIssueId: number;
  letterTemplateId: number;
};

export type GenerateLettersResponse = {};

export const generateLetter = async (request: GenerateLetterRequest) => {
  await executeApiRequest(async () => {
    const response = await axios.post(`/collectionevents/generateletter`, request, {
      responseType: "blob"
    });
    const blobData = new Blob([response.data]);
    const url = window.URL.createObjectURL(blobData);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "letter.zip");
    document.body.appendChild(link);
    link.click();

    return response;
  }, false);
};
